/**
 * Where a «to decide» count lands. The Cockpit's «Da decidere» rows and My Work's queue rows
 * count what is PENDING (the decision summary, bata-platform `decision_summary_statement`); each
 * opens the page that lists those rows and no others. The destinations are declared here, once,
 * so the link and the page's own filter cannot drift apart. Pure: no React, no network.
 */

/** The decision state of a proposal line no disposition names. */
export const PENDING_STATE = 'pending';

/** The state of a dropped-door marker no disposition names: a decision recorded, nothing to decide. */
export const DROPPED_DOOR_STATE = 'droppedDoor';

/** The `decision` filter's id on the replenishment record; its URL key is `f.<id>` (ranked-cap). */
export const DECISION_FILTER_ID = 'decision';

/**
 * Replenishment decisions, on the pending lines: `proposals_served_pending` is the lines no
 * disposition names, dropped-door markers apart, and the record's `pending` state is exactly that.
 */
export const PENDING_PROPOSALS_PARAMS: Readonly<Record<string, string>> = { [`f.${DECISION_FILTER_ID}`]: PENDING_STATE };

/**
 * `?needsAttention=true` — the write-back log narrowed to the commands the summary counts under «needs attention» (ADR 9069):
 * rejected, unknown or past their deadline. The platform lists them with `needs_attention` (ADR 6193), by the predicate it counts
 * them with, so the Cockpit's «Write-back commands to follow» row and the log's «Need attention» figure open exactly that count.
 */
export const NEEDS_ATTENTION_KEY = 'needsAttention';
export const NEEDS_ATTENTION_PARAMS: Readonly<Record<string, string>> = { [NEEDS_ATTENTION_KEY]: 'true' };

/**
 * Moves waiting for a decision: the one run's merged list (bata-reqs ADR 9002 stage 3), where every
 * store-to-store move is decided since the transfer queue was retired (ruling 7). The list opens its
 * own newest move run; a cycle run named with it is not read there.
 */
export const PENDING_TRANSFERS_PATH = '/inseason/compacting-moves';

/** The URL key that page reads its move run from (`compacting/move-run.ts`'s `MOVE_RUN_ID_PARAM`). */
export const MOVE_RUN_ID_KEY = 'moveRunId';
